import bean from 'bean'

export default class FormGA {
  constructor(el) {
    this.el = el
    this.setVars()
    this.bindEvents()
  }

  setVars() {
    this.event = [
      this.el.getAttribute('data-form-label'),
      'Form Submission Attempt'
    ]
      .filter(Boolean)
      .join(' - ')
  }

  bindEvents() {
    bean.on(this.el, 'submit', 'form', this.handleFormSubmit)
  }

  handleFormSubmit = () => {
    window.dataLayer = window.dataLayer || []
    dataLayer.push({
      event: this.event
    })
  }
}
